import styled from 'styled-components';

export const HashLink = styled.a`
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
